import React, { useEffect, useState, useRef } from "react";
import "../../Styles/CommonStyles.scss";
import {
  Button,
  Label,
  PageLink,
  SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import DSBAlogo from "../../Images/DSBAlogo.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import htmlToXlsx from "html-to-xlsx";
import ReportServices from "../../services/ReportServices";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { IEvent } from "../../store/eventApiSlice";
import dayjs from "dayjs";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface Iprops {
  reportType: string;
  callBackClose: () => void;
}

const CommissionReport: React.FC<Iprops> = (props) => {
  const SeminarReportRef = useRef<HTMLDivElement>(null);
  const FunctionReportRef = useRef<HTMLDivElement>(null);
  const VideoReportRef = useRef<HTMLDivElement>(null);

  const eventInfo: IEvent = useSelector(
    (State: RootState) => State.eventapislice.event
  );
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  // const [eventState, setEventState] = useState<string>("Before");
  const [IsActiveDataLoaded, setIsActiveDataLoaded] = useState<boolean>(false);

  const [commissionReport, setCommissionReport] = useState<any>();

  useEffect(() => {
    const getCommissionReport = async () => {
      setIsActiveDataLoaded(true);
      try {
        const response = await ReportServices.getCommissionReport(
          eventInfo.EventType!,
          eventInfo.Id!
        );

        if (response.data.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          console.log("getCommissionReport:", response.data.data);
          setCommissionReport(response.data.data.ParticipantsInfo);
          setIsActiveDataLoaded(false);
        } else {
          setIsActiveDataLoaded(false);
        }
      } catch (error) {
        setIsActiveDataLoaded(false);
      }
    };

    getCommissionReport();
  }, []);

  const handlePrint = useReactToPrint(
    props.reportType === "Seminar"
      ? {
          content: () => SeminarReportRef.current,
        }
      : props.reportType === "Function"
      ? {
          content: () => FunctionReportRef.current,
        }
      : {
          content: () => VideoReportRef.current,
        }
  );

  const handleExport = async (eventType: string) => {
    let reportRef: any;

    switch (eventType) {
      case "Seminar":
        reportRef = SeminarReportRef;
        break;
      case "Function":
        reportRef = FunctionReportRef;
        break;
      case "Video":
        reportRef = VideoReportRef;
        break;
      default:
        throw new Error("Invalid event type");
    }

    const ws = XLSX.utils.table_to_sheet(reportRef.current);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let fileName = "ComissionReport.xlsx";
    if (eventInfo?.UniqueEventId){
      fileName = `${eventInfo.UniqueEventId}_ComissionReport.xlsx`;
    }
    saveAs(blob, fileName);
  };

  return (
    <>
      <div
        className="horizontal-wrapper-spacebetween"
        style={{ alignItems: "center" }}
      >
        <h1 className="page-heading" style={{ height: "auto" }}>
          Report
        </h1>
        {/* <div
          style={{
            display: "flex",
            justifyContent: "start",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div key="EventState" className="checkboxgroup">
            <input
              id="Before Event"
              className="checkbox"
              type="checkbox"
              checked={eventState === "Before" ? true : false}
              onChange={() => setEventState("Before")}
            />
            <span
              style={{
                marginRight: "3rem",
                fontSize: "1.25rem",
                fontWeight: "500",
              }}
            >
              Before Event
            </span>
          </div>
          <div key="EventState" className="checkboxgroup">
            <input
              id="After Event"
              className="checkbox"
              type="checkbox"
              checked={eventState === "After" ? true : false}
              onChange={() => setEventState("After")}
            />
            <span
              style={{
                marginRight: "3rem",
                fontSize: "1.25rem",
                fontWeight: "500",
              }}
            >
              After Event
            </span>
          </div>
        </div> */}
        <div
          className="horizontal-wrapper-rightaligned"
          style={{
            width: "auto",
            marginLeft: "0px",
            marginRight: "0px",
          }}
        >
          <SecondaryWhiteButton
            className="button-wrapper"
            type="button"
            style={{
              marginRight: ".5rem",
              marginLeft: ".5rem",
            }}
            onClick={() => handleExport(props.reportType)}
            // onClick={() => handlePrint()}
          >
            <span style={{ fontWeight: "500" }}>Download as Excel</span>
          </SecondaryWhiteButton>
          <SecondaryWhiteButton
            className="button-wrapper"
            type="button"
            style={{
              marginRight: ".5rem",
              marginLeft: ".5rem",
            }}
            onClick={() => handlePrint()}
          >
            <span style={{ fontWeight: "500" }}>Print / Download as PDF</span>
          </SecondaryWhiteButton>
          <PageLink
            onClick={props.callBackClose}
            // style={{ marginBottom: "2rem" }}
          >
            Close
          </PageLink>
        </div>
        {props.reportType === "Seminar" ? (
          <div className="section-box" ref={SeminarReportRef}>
            <div
              className="grid-report-header-container"
              style={{ alignItems: "center", marginBottom: "2rem" }}
            >
              <div>
                <img className="logo-img " src={DSBAlogo} alt="DSBA" />
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <h2 style={{ height: "auto" }}>Seminar Commission Report</h2>
              </div>
            </div>
            <div
              className="form-wrapper-vertical "
              style={{ width: "100%", marginBottom: "2rem" }}
            >
              <div className="grid-report-title-container">
                <div className="grid-report-title-item1">Event</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {eventInfo.EventName}
                </div>
                <div className="grid-report-title-item1">Event ID</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {eventInfo.UniqueEventId}
                </div>
                <div className="grid-report-title-item1">Date</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {dayjs(eventInfo.StartDateTime)?.format("DD-MMM-YYYY")}
                </div>
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <table
                className="eventlist-table "
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <thead className="table-border">
                  <tr style={{ height: "auto", whiteSpace: "normal" }}>
                    <th style={{ width: "25%", textAlign: "center" }}>
                      Prog Code
                    </th>
                    <th style={{ width: "25%", textAlign: "center" }}>BarID</th>
                    <th style={{ width: "25%", textAlign: "center" }}>Name</th>
                    <th style={{ width: "15%", textAlign: "center" }}>
                      Start Date
                    </th>
                    <th style={{ width: "15%", textAlign: "center" }}>
                      End Date
                    </th>
                    <th style={{ width: "10%", textAlign: "center" }}>
                      Credits
                    </th>
                    <th style={{ width: "10%", textAlign: "center" }}>
                      Credits EE
                    </th>
                  </tr>
                </thead>
                <tbody className="table-border">
                  {/* {Array.from({ length: 45 }).map((_, index) => ( */}
                  {commissionReport &&
                    commissionReport.map((reportLineItem: any) => (
                      <tr style={{ height: "auto", whiteSpace: "normal" }}>
                        <td
                          style={{
                            width: "25%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.UniqueEventId
                            ? reportLineItem.UniqueEventId
                            : null}
                        </td>
                        <td
                          style={{
                            width: "25%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.BarId
                            ? reportLineItem.BarId
                            : null}
                        </td>
                        <td
                          style={{
                            width: "25%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >{reportLineItem && reportLineItem.LastName
                          ? reportLineItem.LastName
                          : null}
                          ,{" "}
                          {reportLineItem && reportLineItem.FirstName
                            ? reportLineItem.FirstName
                            : null}</td>
                        <td
                          style={{
                            width: "15%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.StartDate
                            ? dayjs(reportLineItem.StartDate).format(
                                "DD-MMM-YYYY"
                              )
                            : null}
                        </td>
                        <td
                          style={{
                            width: "15%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.EndDate
                            ? dayjs(reportLineItem.EndDate).format(
                                "DD-MMM-YYYY"
                              )
                            : null}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.Credits
                            ? reportLineItem.Credits
                            : null}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.Ethics
                            ? reportLineItem.Ethics
                            : null}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : props.reportType === "Function" ? (
          <div className="section-box" ref={FunctionReportRef}>
            <div
              className="grid-report-header-container"
              style={{ alignItems: "center", marginBottom: "2rem" }}
            >
              <div>
                <img className="logo-img " src={DSBAlogo} alt="DSBA" />
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <h2 style={{ height: "auto" }}>Function Commission Report</h2>
              </div>
            </div>
            <div
              className="form-wrapper-vertical "
              style={{ width: "100%", marginBottom: "2rem" }}
            >
              <div className="grid-report-title-container">
                <div className="grid-report-title-item1">Event</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {eventInfo.EventName}
                </div>
                <div className="grid-report-title-item1">Event ID</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {eventInfo.UniqueEventId}
                </div>
                <div className="grid-report-title-item1">Date</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {dayjs(eventInfo.StartDateTime)?.format("DD-MMM-YYYY")}
                </div>
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <table
                className="eventlist-table "
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <thead className="table-border">
                  <tr style={{ height: "auto", whiteSpace: "normal" }}>
                    <th style={{ width: "25%", textAlign: "center" }}>
                      Prog Code
                    </th>
                    <th style={{ width: "25%", textAlign: "center" }}>BarID</th>
                    <th style={{ width: "25%", textAlign: "center" }}>Name</th>
                    <th style={{ width: "15%", textAlign: "center" }}>
                      Start Date
                    </th>
                    <th style={{ width: "15%", textAlign: "center" }}>
                      End Date
                    </th>
                    <th style={{ width: "10%", textAlign: "center" }}>
                      Credits
                    </th>
                    <th style={{ width: "10%", textAlign: "center" }}>
                      Credits EE
                    </th>
                  </tr>
                </thead>
                <tbody className="table-border">
                  {/* {Array.from({ length: 45 }).map((_, index) => ( */}
                  {commissionReport &&
                    commissionReport.map((reportLineItem: any) => (
                      <tr style={{ height: "auto", whiteSpace: "normal" }}>
                        <td
                          style={{
                            width: "25%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.UniqueEventId
                            ? reportLineItem.UniqueEventId
                            : null}
                        </td>
                        <td
                          style={{
                            width: "25%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.BarId
                            ? reportLineItem.BarId
                            : null}
                        </td>
                        <td
                          style={{
                            width: "25%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.LastName
                            ? reportLineItem.LastName
                            : null}
                          ,{" "}
                          {reportLineItem && reportLineItem.FirstName
                            ? reportLineItem.FirstName
                            : null}
                        </td>
                        <td
                          style={{
                            width: "15%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.StartDate
                            ? dayjs(reportLineItem.StartDate).format(
                                "DD-MMM-YYYY"
                              )
                            : null}
                        </td>
                        <td
                          style={{
                            width: "15%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.EndDate
                            ? dayjs(reportLineItem.EndDate).format(
                                "DD-MMM-YYYY"
                              )
                            : null}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.Credits
                            ? reportLineItem.Credits
                            : null}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.Ethics
                            ? reportLineItem.Ethics
                            : null}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="section-box" ref={VideoReportRef}>
            <div
              className="grid-report-header-container"
              style={{ alignItems: "center", marginBottom: "2rem" }}
            >
              <div>
                <img className="logo-img " src={DSBAlogo} alt="DSBA" />
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <h2 style={{ height: "auto" }}>Video Commission Report</h2>
              </div>
            </div>
            <div
              className="form-wrapper-vertical "
              style={{ width: "100%", marginBottom: "2rem" }}
            >
              <div className="grid-report-title-container">
                <div className="grid-report-title-item1">Event</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {eventInfo.EventName}
                </div>
                <div className="grid-report-title-item1">Event ID</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {eventInfo.UniqueEventId}
                </div>
                <div className="grid-report-title-item1">Date</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {dayjs(eventInfo.StartDateTime)?.format("DD-MMM-YYYY")}
                </div>
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <table
                className="eventlist-table "
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <thead className="table-border">
                  <tr style={{ height: "auto", whiteSpace: "normal" }}>
                    <th style={{ width: "25%", textAlign: "center" }}>
                      Prog Code
                    </th>
                    <th style={{ width: "25%", textAlign: "center" }}>BarID</th>
                    <th style={{ width: "25%", textAlign: "center" }}>Name</th>
                    <th style={{ width: "15%", textAlign: "center" }}>
                      Start Date
                    </th>
                    <th style={{ width: "15%", textAlign: "center" }}>
                      End Date
                    </th>
                    <th style={{ width: "10%", textAlign: "center" }}>
                      Credits
                    </th>
                    <th style={{ width: "10%", textAlign: "center" }}>
                      Credits EE
                    </th>
                  </tr>
                </thead>
                <tbody className="table-border">
                  {/* {Array.from({ length: 45 }).map((_, index) => ( */}
                  {commissionReport &&
                    commissionReport.map((reportLineItem: any) => (
                      <tr style={{ height: "auto", whiteSpace: "normal" }}>
                        <td
                          style={{
                            width: "25%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.UniqueEventId
                            ? reportLineItem.UniqueEventId
                            : null}
                        </td>
                        <td
                          style={{
                            width: "25%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.BarId
                            ? reportLineItem.BarId
                            : null}
                        </td>
                        <td
                          style={{
                            width: "25%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.LastName
                            ? reportLineItem.LastName
                            : null}
                          ,{" "}
                          {reportLineItem && reportLineItem.FirstName
                            ? reportLineItem.FirstName
                            : null}
                        </td>
                        <td
                          style={{
                            width: "15%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.StartDate
                            ? dayjs(reportLineItem.StartDate).format(
                                "DD-MMM-YYYY"
                              )
                            : null}
                        </td>
                        <td
                          style={{
                            width: "15%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.EndDate
                            ? dayjs(reportLineItem.EndDate).format(
                                "DD-MMM-YYYY"
                              )
                            : null}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.Credits
                            ? reportLineItem.Credits
                            : null}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            overflow: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {reportLineItem && reportLineItem.Ethics
                            ? reportLineItem.Ethics
                            : null}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};
export default CommissionReport;
